import { initCKEditor } from '../shared'

class TemplateCategoryEditView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el

    this.initEditor()
    this.initSelect2()
  }

  initEditor() {
    const el = this.$root.find('.content-editor__editor')
    const publications = (el.data('publications') || []).map(this.camelizeKeys)

    initCKEditor(el.get(0), {
      internalLink: { publications },
    })
      .then(newEditor => {
        this.editor = newEditor
        this.editor.editing.view.focus()
      })
      .catch(error => {
        console.error(error)
      })
  }

  initSelect2() {
    const $templates = this.$root.find('.js-templates')
    $templates.select2()

    // I used ercanertan's solution to make select2 keep selections in order
    // https://github.com/select2/select2/issues/3106#issuecomment-539469984
    $templates.on('select2:select', function (e) {
      const id = e.params.data.id
      const option = $(e.target).children(`[value=${id}]`)
      option.detach()
      $(e.target).append(option).change()
    })
  }

  camelizeKeys(obj) {
    return Object.keys(obj).reduce((camelCasedObj, field) => {
      return {
        ...camelCasedObj,
        [_.camelCase(field)]: obj[field],
      }
    }, {})
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new TemplateCategoryEditView($('.template-category-edit-view'))
})
